export interface MovieItem {
  id: string;
  title: string;
  titleEn: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  categoryLabel: string;
  poster: string;
  rating: number;
  year: number;
  region: string;
  genre: string[];
  director: string;
  cast: string[];
  description: string;
  duration: string;
  episodes?: number;
  isHot: boolean;
  isNew: boolean;
  isFeatured: boolean;
  updateInfo: string;
  views: string;
}

export const categories = [
  { slug: 'movie', label: '电影', icon: 'ri-movie-2-line' },
  { slug: 'tv', label: '电视剧', icon: 'ri-tv-2-line' },
  { slug: 'variety', label: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', label: '动漫', icon: 'ri-rocket-2-line' },
];

export const movies: MovieItem[] = [
  {
    id: 'movie-001',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    category: 'movie',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20a%20giant%20planet%20engine%20in%20space%2C%20dramatic%20lighting%2C%20futuristic%20aesthetic%2C%20dark%20cosmic%20background%20with%20stars%2C%20cinematic%20epic%20scale%2C%20warm%20orange%20and%20teal%20color%20scheme%2C%20clean%20composition%2C%20movie%20poster%20style&width=600&height=840&seq=movie-001&orientation=portrait',
    rating: 8.6,
    year: 2025,
    region: '中国大陆',
    genre: ['科幻', '冒险', '灾难'],
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    description: '在太阳急速老化膨胀、地球面临毁灭的危机下，人类团结一致，在地球表面建造了上万座行星发动机，推动地球逃离太阳系，开启长达2500年的宇宙流浪之旅。第三部中，人类将面临更加严峻的挑战——如何在漫长的星际航行中保持文明的延续。',
    duration: '148分钟',
    isHot: true,
    isNew: true,
    isFeatured: true,
    updateInfo: '2025-01-15 更新',
    views: '1.2亿',
  },
  {
    id: 'movie-002',
    title: '满江红',
    titleEn: 'Full River Red',
    category: 'movie',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20set%20in%20ancient%20China%2C%20red%20lanterns%20in%20a%20courtyard%2C%20dramatic%20shadows%2C%20traditional%20Chinese%20architecture%2C%20mysterious%20atmosphere%2C%20warm%20candlelight%2C%20dark%20cinematic%20style%2C%20clean%20centered%20composition&width=600&height=840&seq=movie-002&orientation=portrait',
    rating: 8.2,
    year: 2023,
    region: '中国大陆',
    genre: ['悬疑', '历史', '喜剧'],
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这场巨大阴谋之中。',
    duration: '159分钟',
    isHot: true,
    isNew: false,
    isFeatured: true,
    updateInfo: '2024-12-20 更新',
    views: '9800万',
  },
  {
    id: 'movie-003',
    title: '孤注一掷',
    titleEn: 'No More Bets',
    category: 'movie',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20about%20online%20gambling%20scams%2C%20dark%20neon%20lit%20room%20with%20computer%20screens%2C%20tense%20atmosphere%2C%20modern%20urban%20crime%20aesthetic%2C%20dramatic%20contrast%20lighting%2C%20green%20and%20red%20accents%2C%20cinematic%20thriller%20style&width=600&height=840&seq=movie-003&orientation=portrait',
    rating: 7.9,
    year: 2023,
    region: '中国大陆',
    genre: ['犯罪', '剧情', '悬疑'],
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君', '王大陆'],
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现完成业绩。一场充满欺骗与危险的猫鼠游戏由此展开。',
    duration: '130分钟',
    isHot: true,
    isNew: false,
    isFeatured: true,
    updateInfo: '2024-11-08 更新',
    views: '8500万',
  },
  {
    id: 'movie-004',
    title: '封神第一部',
    titleEn: 'Creation of the Gods I',
    category: 'movie',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20epic%20movie%20poster%20with%20warriors%20riding%20mythical%20beasts%2C%20ancient%20Chinese%20palace%20and%20battlefield%2C%20dramatic%20golden%20and%20crimson%20color%20palette%2C%20epic%20scale%2C%20traditional%20Chinese%20mythology%20art%20style%2C%20grand%20composition&width=600&height=840&seq=movie-004&orientation=portrait',
    rating: 7.8,
    year: 2023,
    region: '中国大陆',
    genre: ['奇幻', '动作', '战争'],
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    description: '商王殷寿暴虐无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌，一场神魔大战即将拉开帷幕。',
    duration: '148分钟',
    isHot: false,
    isNew: false,
    isFeatured: false,
    updateInfo: '2024-10-15 更新',
    views: '7200万',
  },
  {
    id: 'movie-005',
    title: '热辣滚烫',
    titleEn: 'YOLO',
    category: 'movie',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20about%20boxing%20and%20self-discovery%2C%20warm%20lighting%20in%20a%20boxing%20gym%2C%20inspirational%20atmosphere%2C%20soft%20golden%20hour%20light%2C%20female%20protagonist%20silhouette%2C%20clean%20modern%20aesthetic%2C%20warm%20tone%20movie%20poster&width=600&height=840&seq=movie-005&orientation=portrait',
    rating: 7.6,
    year: 2024,
    region: '中国大陆',
    genre: ['喜剧', '剧情', '运动'],
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    description: '善良的乐莹一直过着平凡的生活，直到遇见拳击教练昊坤。为了赢一次，她决定为自己的人生拼搏一把，走上拳击擂台。这不仅是一场身体的较量，更是一次灵魂的蜕变。',
    duration: '129分钟',
    isHot: true,
    isNew: true,
    isFeatured: true,
    updateInfo: '2025-01-10 更新',
    views: '1.5亿',
  },
  {
    id: 'movie-006',
    title: '消失的她',
    titleEn: 'Lost in the Stars',
    category: 'movie',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20suspense%20movie%20poster%20with%20tropical%20island%20and%20ocean%20at%20night%2C%20moody%20dark%20blue%20tones%2C%20disappearing%20figure%20silhouette%2C%20tense%20atmospheric%20lighting%2C%20cinematic%20thriller%20aesthetic%2C%20clean%20centered%20composition&width=600&height=840&seq=movie-006&orientation=portrait',
    rating: 7.5,
    year: 2023,
    region: '中国大陆',
    genre: ['悬疑', '犯罪', '剧情'],
    director: '崔睿',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    description: '何非的妻子李木子在海外旅行时神秘失踪，当他报案后，一个陌生女人突然出现声称自己就是他的妻子。在金牌律师陈麦的帮助下，何非开始寻找真相，却发现这背后隐藏着更大的秘密。',
    duration: '121分钟',
    isHot: false,
    isNew: false,
    isFeatured: false,
    updateInfo: '2024-09-22 更新',
    views: '6800万',
  },
  {
    id: 'tv-001',
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    category: 'tv',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20set%20in%201990s%20Shanghai%2C%20neon%20lights%20and%20vintage%20cityscape%2C%20elegant%20retro%20aesthetic%2C%20warm%20golden%20neon%20glow%2C%20Shanghai%20Bund%20night%20scene%2C%20nostalgic%20atmosphere%2C%20clean%20centered%20composition&width=600&height=840&seq=tv-001&orientation=portrait',
    rating: 9.0,
    year: 2023,
    region: '中国大陆',
    genre: ['剧情', '爱情', '时代'],
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    description: '九十年代的上海，人人都想抓住时代的机遇。阿宝白手起家，凭借敏锐的商业嗅觉和诚信品格，在上海滩闯出一片天地。从一个默默无闻的小青年，到上海滩的风云人物，阿宝经历了商海沉浮和人生冷暖。',
    duration: '30集',
    episodes: 30,
    isHot: true,
    isNew: false,
    isFeatured: true,
    updateInfo: '2024-12-30 更新完',
    views: '2.3亿',
  },
  {
    id: 'tv-002',
    title: '庆余年第二季',
    titleEn: 'Joy of Life S2',
    category: 'tv',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20drama%20poster%20with%20ancient%20Chinese%20palace%20and%20martial%20arts%20hero%2C%20dramatic%20golden%20and%20red%20aesthetic%2C%20traditional%20Chinese%20costume%20drama%20style%2C%20epic%20cinematic%20composition%2C%20warm%20rich%20color%20palette&width=600&height=840&seq=tv-002&orientation=portrait',
    rating: 8.8,
    year: 2024,
    region: '中国大陆',
    genre: ['古装', '权谋', '武侠'],
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    description: '范闲从北齐归来后，发现自己卷入了更加复杂的朝堂斗争。庆帝的猜忌、二皇子的野心、长公主的阴谋，各方势力暗流涌动。范闲必须运用自己的智慧和勇气，在权力的漩涡中寻找生存之道。',
    duration: '36集',
    episodes: 36,
    isHot: true,
    isNew: true,
    isFeatured: true,
    updateInfo: '2025-01-18 更新至28集',
    views: '3.1亿',
  },
  {
    id: 'tv-003',
    title: '三体',
    titleEn: 'Three-Body',
    category: 'tv',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20about%20alien%20civilization%2C%20cosmic%20mystery%2C%20three%20suns%20in%20space%2C%20dark%20futuristic%20aesthetic%2C%20mysterious%20radio%20telescope%2C%20cold%20scientific%20atmosphere%2C%20clean%20cinematic%20composition&width=600&height=840&seq=tv-003&orientation=portrait',
    rating: 8.5,
    year: 2023,
    region: '中国大陆',
    genre: ['科幻', '悬疑', '剧情'],
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    description: '纳米科学家汪淼被警官史强带到联合作战中心，发现科学家们接连自杀的背后，似乎与一个名为"科学边界"的组织有关。随着调查的深入，一个来自外星文明——三体世界的信息逐渐浮出水面。',
    duration: '30集',
    episodes: 30,
    isHot: true,
    isNew: false,
    isFeatured: true,
    updateInfo: '2024-11-20 更新完',
    views: '1.8亿',
  },
  {
    id: 'tv-004',
    title: '狂飙',
    titleEn: 'The Knockout',
    category: 'tv',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20about%20police%20and%20gangsters%2C%20dark%20urban%20street%20scene%2C%20neon%20signs%2C%20tense%20confrontation%20atmosphere%2C%20gritty%20realistic%20style%2C%20dramatic%20lighting%2C%20clean%20centered%20composition&width=600&height=840&seq=tv-004&orientation=portrait',
    rating: 8.7,
    year: 2023,
    region: '中国大陆',
    genre: ['犯罪', '剧情', '悬疑'],
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    description: '一线刑警安欣在与黑恶势力的斗争中，历经二十年风雨洗礼，从意气风发的青年警官变为两鬓斑白的中年人。在与以高启强为首的黑恶势力漫长的较量中，正义与邪恶展开了惊心动魄的角逐。',
    duration: '39集',
    episodes: 39,
    isHot: true,
    isNew: false,
    isFeatured: false,
    updateInfo: '2024-10-05 更新完',
    views: '4.2亿',
  },
  {
    id: 'variety-001',
    title: '奔跑吧·第12季',
    titleEn: 'Keep Running S12',
    category: 'variety',
    categoryLabel: '综艺',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20running%20in%20colorful%20outdoor%20setting%2C%20bright%20sunny%20day%2C%20energetic%20fun%20atmosphere%2C%20vibrant%20colors%20green%20grass%20and%20blue%20sky%2C%20cheerful%20group%20activity%2C%20clean%20composition&width=600&height=840&seq=variety-001&orientation=portrait',
    rating: 7.8,
    year: 2024,
    region: '中国大陆',
    genre: ['真人秀', '户外', '竞技'],
    director: '姚译添',
    cast: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞', '宋雨琦'],
    description: '浙江卫视王牌户外竞技真人秀节目，常驻嘉宾与飞行嘉宾组队完成各种趣味挑战任务，在奔跑中传递欢乐与正能量。本季新增更多创新游戏环节，带你感受不一样的奔跑体验。',
    duration: '12期',
    isHot: true,
    isNew: true,
    isFeatured: true,
    updateInfo: '2025-01-20 更新至第6期',
    views: '8900万',
  },
  {
    id: 'variety-002',
    title: '歌手2024',
    titleEn: 'Singer 2024',
    category: 'variety',
    categoryLabel: '综艺',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20TV%20show%20poster%20with%20spotlight%20on%20stage%2C%20dramatic%20concert%20lighting%2C%20microphone%20in%20spotlight%2C%20dark%20elegant%20background%2C%20golden%20stage%20lights%2C%20music%20performance%20atmosphere%2C%20clean%20centered%20composition&width=600&height=840&seq=variety-002&orientation=portrait',
    rating: 8.3,
    year: 2024,
    region: '中国大陆',
    genre: ['音乐', '竞演', '真人秀'],
    director: '洪涛',
    cast: ['那英', '汪苏泷', '杨丞琳', 'Faouzia', 'Chante Moore'],
    description: '华语乐坛最高水准的音乐竞演节目，汇聚国内外顶级歌手同台竞技。每一位歌手都将用最纯粹的歌声征服观众和评审，角逐年度歌王桂冠。现场乐队伴奏，全程直播，真实展现每一位歌手的实力。',
    duration: '13期',
    isHot: true,
    isNew: false,
    isFeatured: false,
    updateInfo: '2024-09-15 更新完',
    views: '1.6亿',
  },
  {
    id: 'anime-001',
    title: '哪吒之魔童降世',
    titleEn: 'Ne Zha',
    category: 'anime',
    categoryLabel: '动漫',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20of%20mythological%20hero%20Ne%20Zha%20with%20fire%20wheels%20and%20red%20ribbon%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20traditional%20Chinese%20mythology%20art%20style%2C%20epic%203D%20animation%20quality%2C%20dramatic%20lighting&width=600&height=840&seq=anime-001&orientation=portrait',
    rating: 8.4,
    year: 2019,
    region: '中国大陆',
    genre: ['动画', '奇幻', '动作'],
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    description: '天地灵气孕育出一颗混元珠，元始天尊将其提炼成灵珠和魔丸。灵珠投胎为人，助周伐纣时可堪大用；魔丸则会诞出魔王，为祸人间。然而阴差阳错，灵珠和魔丸被调包，本应是灵珠英雄的哪吒却成了混世魔王。',
    duration: '110分钟',
    isHot: true,
    isNew: false,
    isFeatured: true,
    updateInfo: '2024-08-20 更新',
    views: '2.5亿',
  },
  {
    id: 'anime-002',
    title: '长安三万里',
    titleEn: 'Chang An',
    category: 'anime',
    categoryLabel: '动漫',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20movie%20poster%20set%20in%20ancient%20Tang%20Dynasty%20Chang%20An%20city%2C%20poets%20under%20moonlight%2C%20traditional%20Chinese%20ink%20painting%20style%20combined%20with%203D%20animation%2C%20elegant%20classical%20aesthetic%2C%20golden%20moon%20and%20flying%20birds%2C%20poetic%20atmosphere&width=600&height=840&seq=anime-002&orientation=portrait',
    rating: 8.2,
    year: 2023,
    region: '中国大陆',
    genre: ['动画', '历史', '传记'],
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适回忆起自己与李白跨越数十载的情谊，以及那个群星璀璨的大唐盛世中的各位诗人。',
    duration: '168分钟',
    isHot: false,
    isNew: false,
    isFeatured: false,
    updateInfo: '2024-07-12 更新',
    views: '9500万',
  },
  {
    id: 'tv-005',
    title: '唐朝诡事录之西行',
    titleEn: 'Strange Tales of Tang Dynasty 2',
    category: 'tv',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20TV%20drama%20poster%20set%20in%20ancient%20Tang%20Dynasty%2C%20dark%20palace%20corridor%20with%20lanterns%2C%20mysterious%20atmosphere%2C%20traditional%20Chinese%20costume%20style%2C%20detective%20theme%2C%20warm%20candlelight%20shadows%2C%20clean%20centered%20composition&width=600&height=840&seq=tv-005&orientation=portrait',
    rating: 8.1,
    year: 2024,
    region: '中国大陆',
    genre: ['古装', '悬疑', '探案'],
    director: '郭靖宇',
    cast: ['杨旭文', '杨志刚', '郜思雯', '陈创'],
    description: '大唐年间，狄仁杰弟子苏无名与卢凌风再度携手破案，一路西行，遭遇各种离奇诡异案件。从长安到西域，每一起案件背后都隐藏着不为人知的秘密，两人凭借智慧与勇气逐一揭开真相。',
    duration: '36集',
    episodes: 36,
    isHot: true,
    isNew: true,
    isFeatured: false,
    updateInfo: '2025-01-22 更新至20集',
    views: '7600万',
  },
  {
    id: 'movie-007',
    title: '年会不能停！',
    titleEn: 'Johnny Keep Walking!',
    category: 'movie',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20movie%20poster%20in%20modern%20office%20setting%2C%20colorful%20office%20party%20scene%2C%20funny%20corporate%20culture%20satire%2C%20bright%20indoor%20lighting%2C%20cheerful%20chaotic%20atmosphere%2C%20modern%20Chinese%20office%20aesthetic%2C%20clean%20composition&width=600&height=840&seq=movie-007&orientation=portrait',
    rating: 8.3,
    year: 2023,
    region: '中国大陆',
    genre: ['喜剧', '剧情'],
    director: '董润年',
    cast: ['大鹏', '白客', '庄达菲', '王迅', '孙艺洲'],
    description: '钳工胡建林阴差阳错被调入集团总部，从"工厂"到"大厂"，从"蓝领"变"金领"。在职场新人马杰的帮助下，胡建林经历了一系列啼笑皆非的职场故事，也发现大厂光鲜背后隐藏的种种问题。',
    duration: '117分钟',
    isHot: false,
    isNew: false,
    isFeatured: false,
    updateInfo: '2024-06-18 更新',
    views: '5600万',
  },
];

export const featuredMovies = movies.filter(m => m.isFeatured);
export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);

export function getMoviesByCategory(slug: string): MovieItem[] {
  return movies.filter(m => m.category === slug);
}

export function getMovieById(id: string): MovieItem | undefined {
  return movies.find(m => m.id === id);
}

export function getRelatedMovies(movie: MovieItem, limit: number = 4): MovieItem[] {
  return movies
    .filter(m => m.id !== movie.id && (m.category === movie.category || m.genre.some(g => movie.genre.includes(g))))
    .slice(0, limit);
}